var _path, _rect, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuyBacks = function SvgBuyBacks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#buy-backs_svg__a)",
    fillRule: "evenodd",
    d: "M35 70c19.33 0 35-15.67 35-35S54.33 0 35 0 0 15.67 0 35s15.67 35 35 35",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    x: 17,
    y: 23,
    fill: "#6A659B",
    rx: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A19EC5",
    d: "M17 37h36v4H17z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "buy-backs_svg__a",
    x1: 35,
    x2: 35,
    y1: 0,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E8F3"
  })))));
};
export { SvgBuyBacks as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAiIGhlaWdodD0iNzAiIHZpZXdCb3g9IjAgMCA3MCA3MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zNSA3MEM1NC4zMyA3MCA3MCA1NC4zMyA3MCAzNUM3MCAxNS42NyA1NC4zMyAwIDM1IDBDMTUuNjcgMCAwIDE1LjY3IDAgMzVDMCA1NC4zMyAxNS42NyA3MCAzNSA3MFoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcikiLz4KPHJlY3QgeD0iMTciIHk9IjIzIiB3aWR0aD0iMzYiIGhlaWdodD0iMjQiIHJ4PSI0IiBmaWxsPSIjNkE2NTlCIi8+CjxyZWN0IHg9IjE3IiB5PSIzNyIgd2lkdGg9IjM2IiBoZWlnaHQ9IjQiIGZpbGw9IiNBMTlFQzUiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjM1IiB5MT0iMCIgeDI9IjM1IiB5Mj0iNzAiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0id2hpdGUiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRTdFOEYzIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";